module.exports = __webpack_public_path__ + "static/media/ellipsis-v-alt.bcf80d60.svg";